import { ErrorPage } from '@uhg-uicl/ui-core/dist';
import PageWrapper from 'containers/PageWrapper';
import { StyledFooterPages } from 'containers/PrivacySecurity/constants';
import { authenticationMessages } from 'containers/Security/modules/constants';
import { UserProfile } from 'containers/Security/modules/types';
import { getLoggedInUser } from 'containers/Security/modules/utils';
import { ComponentType } from 'react';
import { useAuth } from 'react-oidc-context';

type WithRoleAndPermissionProps = {
  user: UserProfile;
};

export const WithRoleAndPermission =
  (requiredPermission?: string, requiredRole?: string) =>
  <P extends object>(
    WrappedComponent: ComponentType<P & WithRoleAndPermissionProps>,
  ): React.FC<P & WithRoleAndPermissionProps> => {
    const WithRoleAndPermission = (props) => {
      const auth = useAuth();
      const user: UserProfile = getLoggedInUser(auth);
      const { ...rest } = props;
      const userPermissions = user.permissions;
      //Check if the user has at least one role and one permission if no specific role or permission is specified
      if (!requiredRole && !requiredPermission) {
        const hasRole = userPermissions.length > 0;
        const hasPermission = userPermissions.some(
          (rolePermissions) => rolePermissions.permissions.length > 0,
        );
        if (hasPermission && hasRole) {
          return <WrappedComponent {...(rest as P)} user={user} />;
        }
      } else {
        //check if the user has the required role and permission (if specified)
        const hasRole =
          !requiredRole ||
          userPermissions.some((rolePermissions) => rolePermissions.role === requiredRole);
        const hasPermission =
          !requiredPermission ||
          userPermissions.some((rolePermissions) =>
            rolePermissions.permissions.includes(requiredPermission),
          );
        if (hasRole && hasPermission) {
          return <WrappedComponent {...(rest as P)} user={user} />;
        }
      }
      return (
        <StyledFooterPages>
          <PageWrapper
            listPaneContent={
              <ErrorPage
                dataTestId={'test-error-page'}
                title="Not Authorized"
                message={authenticationMessages.notAuthorized}
              />
            }
          />
        </StyledFooterPages>
      );
    };
    return WithRoleAndPermission;
  };
